import imgUrl from '@/assets/logo.svg';

export const LogoLink = () => {
  return (
    <a
      className="flex justify-center"
      href="https://featurebuddy.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="bg-white text-center text-xs text-balance size-10 rounded-md p-0.5">
        <img src={imgUrl} />
      </div>
    </a>
  );
};
